import { getTelLinkFromPhone } from "./getTelLinkFromPhone";
import { getWhatsappLinkFromPhone } from "./getWhatsappLinkFromPhone";

export function getContact(component) {
  const { tel, whatsapp, email, address, google_maps } = component;
  const contact = {};

  if (tel) {
    let telSplit = tel.split(";");

    if (Array.isArray(telSplit) && telSplit.length > 1) {
      let telArray = [];
      telSplit.forEach(function (val) {
        telArray.push({
          name: "Telefone",
          text: val,
          link: getTelLinkFromPhone(val),
          target: "_self",
          icon: "fa-phone-alt",
          size: 16,
        });
      });

      contact.tel = telArray;
    } else {
      contact.tel = {
        name: "Telefone",
        text: tel,
        link: getTelLinkFromPhone(tel),
        target: "_self",
        icon: "fa-phone-alt",
        size: 16,
      };
    }
  }

  if (whatsapp) {
    let whatsappSplit = whatsapp.split(";");

    if (Array.isArray(whatsappSplit) && whatsappSplit.length > 1) {
      let whatsappArray = [];
      whatsappSplit.forEach(function (val) {
        whatsappArray.push({
          name: "WhatsApp",
          text: val,
          link: getWhatsappLinkFromPhone(val),
          target: "_blank",
          icon: "fab fa-whatsapp",
          size: 20,
        });
      });

      contact.whatsapp = whatsappArray;
    } else {
      contact.whatsapp = {
        name: "WhatsApp",
        text: whatsapp,
        link: getWhatsappLinkFromPhone(whatsapp),
        target: "_blank",
        icon: "fab fa-whatsapp",
        size: 20,
      };
    }
  }

  if (address) {
    contact.address = {
      name: "Endereço",
      text: address,
      link: google_maps,
      target: "_blank",
      icon: "fa-map-marker-alt",
      size: 18,
    };
  }

  if (email) {
    contact.email = {
      name: "E-mail",
      text: email,
      link: "mailto:" + email,
      target: "_self",
      icon: "fa-envelope",
      size: 18,
    };
  }

  return contact;
}
